<template>
  <v-card flat>
    <v-sheet max-width="250" class="mx-auto reading" v-if="!configHasBeenRead">
      <div>
        <v-progress-circular indeterminate :size="60"></v-progress-circular>
      </div>
      <div>
        <p>
          Even geduld aub...<br />
          De configuratie wordt ingelezen
        </p>
      </div>
    </v-sheet>

    <v-sheet
      max-width="250"
      class="mx-auto reading"
      v-if="configHasBeenRead && !appIsActive"
    >
      <div>
        <p>
          De aanmeldingslijst is niet actief!<br />
          Je kan je via deze weg niet aanmelden bij {{ clubName }}
        </p>
        <v-btn
          class="mb-8"
          color="blue"
          size="large"
          variant="tonal"
          block
          @click="openClubUrl"
        >
          Sluit
        </v-btn>
      </div>
    </v-sheet>

    <v-card
      class="mx-auto"
      max-width="1200"
      v-if="configHasBeenRead && appIsActive"
    >
      <v-toolbar flat :height="getToolBarHeight">
        <v-toolbar-title class="text-grey" v-if="appTitle">
          {{ appTitle }}
        </v-toolbar-title>
      </v-toolbar>

      <v-divider v-if="!isMobile"></v-divider>

      <v-card-text style="height: 725px" v-if="configHasBeenRead">
        <router-view :key="$route.fullPath" v-slot="slotProps">
          <transition name="route" mode="out-in">
            <component :is="slotProps.Component"></component>
          </transition>
        </router-view>
      </v-card-text>

      <v-banner
        lines="one"
        icon="mdi-lightbulb-question"
        color="primary"
        density="compact"
        v-if="!isMobile"
      >
        <template v-slot:text>
          Created by G&sup2;Soft, Lochristi
          <span class="privacy" v-if="appFooter">- {{ appFooter }}</span>
        </template>

        <template v-slot:actions>
          <a href="https://www.ledenfiches.be" target="_blank">
            <v-btn> Check it out </v-btn>
          </a>
        </template>
      </v-banner>
    </v-card>
  </v-card>
</template>

<script>
export default {
  data: () => ({}),
  components: {},
  computed: {
    isMobile() {
      return this.$isMobile();
    },
    getToolBarHeight() {
      if (this.$isMobile()) {
        return "35";
      } else {
        return "70";
      }
    },
    configHasBeenRead() {
      return this.$store.getters["configHasBeenRead"];
    },
    appIsActive() {
      const config = this.$store.getters["config"];
      return config && config.isActive == 1 ? true : false;
    },
    appTitle() {
      const config = this.$store.getters["config"];
      if (this.$isMobile()) {
        return config.clubName;
      } else {
        return config.appTitle;
      }
    },
    clubName() {
      const config = this.$store.getters["config"];
      return config.clubName;
    },
    appFooter() {
      const config = this.$store.getters["config"];
      return config.appFooter;
    },
  },
  methods: {
    openClubUrl() {
      const config = this.$store.getters["config"];
      window.open(config.clubUrl, "_self");
    },
  },
  created() {
    if (process.env.NODE_ENV === "production") {
      fetch("./getSettings.php", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }).then((response) => {
        response.json().then((json) => {
          this.$store.dispatch("apiUrl", {
            apiUrl: json.config.apiUrl,
          });
          this.$store.dispatch("config");
        });
      });
    } else {
      console.log("Development environment");
      this.$store.dispatch("apiUrl", {
        apiUrl: "http://192.168.0.237:8092/scriptcase/G2Soft/api/",
      });
      this.$store.dispatch("config");
    }
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap");
@import url("./../settings.css");

* {
  box-sizing: border-box;
}

html {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
}

body {
  margin: 0;
  color: var(--var-font-color);
}

.reading {
  align-content: center;
  text-align: center;
  margin-top: 10px;
}

.privacy {
  font-size: 10px;
  font-style: italic;
}
</style>
